<template>
  <div class="main-wrapper" >

    <div class="main-scroll">
      <nav-com :flag="flag"></nav-com>
      <resume-com></resume-com>
      <foot-com class="foots"></foot-com>
    </div>

    <bottom-backtop></bottom-backtop>
  </div>
</template>

<script>
import NavCom from '../common/navs';
import FootCom from '../common/foots';
import resumeCom from './resume';
import BottomBacktop from '../common/BottomBacktop';


export default {
  name: 'resumeList',
  components: {
    NavCom,
    FootCom,
    resumeCom,
    BottomBacktop
  },
  data() {
    return {
      flag: false,
    }
  },
}
</script>

<style lang="scss" scoped></style>
